import React from 'react'
import { Box } from '@mui/material'
import { format, parseISO } from 'date-fns'

// Local imports
import WithdrawRequestWarning from './withdrawRequestWarning'
import AdxButton from 'components/custom/AdxButton'

const RequestButtonOptions = ({ requestStatus, updatedAt, handleSubmit }) => {
  switch (requestStatus) {
    case 10:
      return <WithdrawRequestWarning />
    case 11:
      return null
    case 12:
      return <WithdrawRequestWarning />
    case 14:
      return (
        <Box
          sx={{
            width: 1,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            columnGap: 1,
            rowGap: 1,
          }}
        >
          <WithdrawRequestWarning sx={{ width: { xs: 1, sm: 1 / 4 } }} />
          <AdxButton
            variant={'contained'}
            sx={{ width: { xs: 1, sm: 3 / 4 } }}
            onClick={handleSubmit}
          >
            Submit Supporting Documents
          </AdxButton>
        </Box>
      )
    case 15:
      return <WithdrawRequestWarning />
    case 16:
      return (
        <AdxButton
          variant={'ghost'}
          fullWidth
          disabled
          sx={{
            backgroundColor: 'gray-background.main',
            color: 'light-gray-text.main',
            '&:disabled': {
              color: 'light-gray-text.main',
            },
          }}
        >
          Cancelled on {format(parseISO(updatedAt), `dd/MM/yyyy, hh:mmaa`)}
        </AdxButton>
      )
    case 17:
      return <WithdrawRequestWarning />
    case 18:
      return <WithdrawRequestWarning />
    default:
      return null
  }
}

export default RequestButtonOptions
